import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Modal, Form, Input, Space, Button, Upload, TreeSelect, Select, Row, Col, message, InputNumber } from 'antd'
import { DeleteOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from '../../../tool/axios'
import { apiPrefix } from '../../../js/config'
import { formItemLayout, tailLayout } from '../../../js/globalParam'

import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'

import E from 'wangeditor'
import _ from 'lodash'

const { Option } = Select

const uploadFile = (e: { fileList: [] }) => {
    if (Array.isArray(e)) {
        return e
    }

    return e && e.fileList
}

const uploadButton = (
    <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
    </div>
)

type TreeData = {
    title: string, // '产康分类1'
    value: string, // '0-0'
    key: string, // '0-0'
    children: {
        title: string, // '项目1'
        value: string, //  '0-0-0'
        key: string, // '0-0-0'
    }[]
}

export default function AddEdit() {

    const [fileList, setFileList] = useState<any[]>([])

    const [treeData, setTreeData] = useState<TreeData[]>([])
    const [treeData2, setTreeData2] = useState<TreeData[]>([])

    const [treeDataOrigin, setTreeDataOrigin] = useState<any[]>([])
    const [treeDataOrigin2, setTreeDataOrigin2] = useState<any[]>([])

    const [editorVisible, setEditorVisible] = useState<boolean>(false)
    const [editor, setEditor] = useState<null | E>(null)
    const [editType, setEditType] = useState<string>('')

    const [tagList, setTagList] = useState<{ name: string, color: string, id: number }[]>([])
    const [ckSelected, setCkSelected] = useState<string[]>([])
    const [ckSelectedJson, setCkSelectedJson] = useState<any[]>([])

    const [ckSelected2, setCkSelected2] = useState<string[]>([])
    const [ckSelectedJson2, setCkSelectedJson2] = useState<any[]>([])

    const [pageTitle, setPageTitle] = useState<string>('')
    const [formInstance] = Form.useForm()

    let { id }: { id: string } = useParams()

    const handleTreeSelectChange = (value: string[]) => {
        setCkSelected(value)
    }

    const showEditModal = (which: string) => {
        setEditType(which)
        setEditorVisible(true)

        which === 'service' ? editor?.txt.html(formInstance.getFieldValue('item_intro_detail')) : editor?.txt.html(formInstance.getFieldValue('attention'))
    }

    const renderEditor = (cb: (e: any) => void) => {
        const editor = new E('.editor')
        editor.config.uploadFileName = "files"
        editor.config.uploadImgServer = apiPrefix + '/global/upload_pic'

        editor.config.uploadImgParams = {
            fileType: '1',
            bucketType: '4'
        }

        editor.config.uploadImgHeaders = {
            token: Cookies.get('token') || ''
        }

        editor.config.uploadImgHooks = {
            // 例如，服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
            customInsert: function (insertImgFn: any, result: any) {
                // result 即服务端返回的接口
                insertImgFn(result.data[0])
            }
        }
        editor.create()

        cb(editor)
        setEditor(editor)
    }

    const handleModalOk = () => {
        let html = editor?.txt.html()
        editType === 'service' ? formInstance.setFieldsValue({ item_intro_detail: html }) : formInstance.setFieldsValue({ attention: html })

        setEditorVisible(false)
        editor?.txt.html('')
    }

    // 提交
    const onFinish = (values: any) => {
        let item_flag: any[] = []

        let url: string = '',
            postData = {
                item_name: values.item_name,
                item_flag: values.item_flag.join(','),
                suggest_price: values.suggest_price,
                item_intro_detail: values.item_intro_detail,
                attention: values.attention,
                file_url_list: values.item_pic_vedio.map((item: any) => { return item.response.data.toString() }) || [],
                item_attribute_base: ckSelectedJson.length ? ckSelectedJson : []
            }

        if (values.suggest_price == 0) {
            message.warning('参考价格不能为0 !')
            return false
        }

        if (values.item_flag.length > 3) {
            message.warning('项目标签数不能超过三个!')
            return false

        } else {
            // 拼接项目标签颜色给小程序用
            if (values.item_flag.length) {
                values.item_flag.map((item: any) => {
                    item_flag.push(`${item}&&&#000000`)
                })
            }
        }

        if (!id) {
            // 若主键为空，则新增
            url = '/chankang_center/item_package/add'
            postData.item_flag = item_flag.toString()

            axiosHandleEvent.post(url, { ...postData })

        } else {
            // 若主键不为空，则编辑
            url = '/chankang_center/item_package/update'
            postData.item_flag = item_flag.toString()

            axiosHandleEvent.post(url, { item_id: id, ...postData })
        }
    }

    const translateToTreeData = (data: { item_type_name: string, item_type_id: string, singles: [] }[]): TreeData[] => {
        return data.map(el => ({
            title: el.item_type_name, // '产康分类1'
            value: el.item_type_id, // '0-0'
            key: el.item_type_id, // '0-0'
            disabled: el.singles.length ? false : true,
            children: el.singles.map((el: { item_id: string, item_name: string }) => ({
                title: el.item_name, // '项目1'
                value: el.item_id, //  '0-0-0'
                key: el.item_id, // '0-0-0'
            }))
        }))
    }

    const deleteTreeOption = (id: string) => {
        let data = ckSelectedJson.filter(item => item.item_id !== id)
        setCkSelectedJson(data)

        let selectIdList = data.map((el: any) => {
            return el.item_id
        })
        setCkSelected(selectIdList)

        formInstance.setFieldsValue({ item_list_extra: selectIdList })
    }

    // 金额输入框小数点控制后两位
    const limitDecimals = (value: any) => {
        const reg = /^(\-)*(\d+)\.(\d\d).*$/;
        // 取数字
        const data = value.replace(/[^0-9.]/g, "")

        // 取小数点后两位
        return data.replace(reg, '$1$2.$3')
    }

    const handleProjectChange = (value: any, index: number, attr: string) => {
        let newArr = _.cloneDeep(ckSelectedJson)
        newArr[index][attr] = Number(value)
        setCkSelectedJson(newArr)

        // 同步源数据
        let newArr2 = _.cloneDeep(treeDataOrigin)
        newArr2.forEach(el => {
            if (el.singles.length) {
                el.singles.forEach((el2: any) => {
                    if (el2.item_id == newArr[index].item_id) { el2[attr] = newArr[index][attr] }
                })
            }
        })

        setTreeDataOrigin(newArr2)
    }

    useEffect(() => {
        // 获取标签
        baseAxiosNoInfo.get('/global/flag_pool_list', { params: { flag_type: 1 } }).then((response: any) => {
            setTagList(response)
        })

        // 获取产康单项
        baseAxiosNoInfo.get('/chankang_center/item_single/select_list').then((response: any) => {
            if (response) {
                response.forEach((el: { singles: any[], id: string }) => {
                    el.singles.forEach(el2 => {
                        if (el2.item_id) {
                            Object.assign(el2, { item_id: el2.item_id, standard_times: Number(el2.standard_times) })
                        }
                    })
                })

                setTreeDataOrigin(response)
                setTreeDataOrigin2(response)

                setTreeData(translateToTreeData(response))
                setTreeData2(translateToTreeData(response))

                if (id) {
                    getDetailById(response)
                    setPageTitle('编辑产康套餐')

                } else {
                    setPageTitle('新增产康套餐')
                }
            }
        })
    }, [1])

    const getDetailById = (treeData: any) => {
        baseAxiosNoInfo.get('/chankang_center/item_package/detail', { params: { item_id: id } }).then((res: any) => {
            if (res) {
                let formData: any = {
                    item_name: '',
                    suggest_price: null,
                    attention: ''
                }

                for (let attr in formData) { formData[attr] = res[attr] }

                let flag = res.item_flag.split(',')
                formData.item_flag = flag.map((el: any) => { return el.split('&&&')[0] })
                formData.item_pic_vedio = res.file_url_list.map((el: { file_url: string, id: string }) => ({ url: el, id: el, uid: el, response: { data: [el] } }))
                formData.choose_type = res.choose_type

                // 筛选产康单项
                if (res.item_attribute_base.length) { // 基本项目
                    setCkSelectedJson(
                        res.item_attribute_base.map((el: any) => ({
                            item_id: el.item_id,
                            item_name: el.item_name,
                            standard_times: el.standard_times ? Number(el.standard_times) : 0
                        }))
                    )

                    formData.item_list_extra = res.item_attribute_base.map((el: any) => {
                        return el.item_id
                    })

                    // 同步源数据
                    res.item_attribute_base.forEach((el1: any) => {
                        treeData.forEach((el2: any) => {
                            if (el2.singles.length) {
                                el2.singles.forEach((el3: any) => {
                                    if (el3.item_id == el1.item_id) { el3.standard_times = el1.standard_times }
                                })
                            }
                        })
                    })

                    setTreeDataOrigin(treeData)
                }

                formData.item_intro_detail = Base64.fromBase64(res.item_intro_detail)
                formData.attention = res.attention ? Base64.fromBase64(res.attention) : ''

                formInstance.setFieldsValue(formData)
            }
        })
    }

    useEffect(() => {
        let arr: {}[] = []

        ckSelected.forEach(el => {
            treeDataOrigin.forEach(el2 => {
                if (el2.singles.length) {
                    el2.singles.forEach((el3: { item_id: string }) => {
                        if (el3.item_id === el) {
                            arr.push(el3)
                        }
                    })
                }
            })
        })

        setCkSelectedJson(arr)
    }, [ckSelected])

    useEffect(() => {
        let arr: {}[] = []

        ckSelected2.forEach(el => {
            treeDataOrigin2.forEach(el2 => {
                el2.singles.forEach((el3: { item_id: string }) => {
                    if (el3.item_id === el) { arr.push(el3) }
                })
            })
        })

        setCkSelectedJson2(arr)
    }, [ckSelected2])

    useEffect(() => {
        if (editorVisible && editor === null && editType.length > 0) {
            renderEditor((e: any) => {
                editType === 'service' ? e?.txt.html(formInstance.getFieldValue('item_intro_detail')) : e?.txt.html(formInstance.getFieldValue('attention'))
            })
        }
    }, [editorVisible])

    const TagOptions = tagList.map((el: any) => (<Option value={el.label_name} key={el.id}>{el.label_name}</Option>))

    return <div className="common-level2-edit">
        {/* 产康中心 -> 产康项目管理 -> 产康套餐管理 -> 新增或编辑 */}
        <h2>{pageTitle}</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={formInstance} name="validate_editor" onFinish={onFinish} >
                <Form.Item label="套餐名称" name="item_name" rules={[{ required: true, message: '必须填写套餐名称' }]}  >
                    <Input />
                </Form.Item>

                <Form.Item label="套餐标签（可多选）" name="item_flag" rules={[{ required: true, message: '必须选择套餐标签' }]} >
                    <Select mode="tags" style={{ width: '100%' }} placeholder="选择标签" >
                        {TagOptions}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="套餐图片"
                    valuePropName="fileList"
                    getValueFromEvent={uploadFile}
                    name="item_pic_vedio"
                    extra="（最多可上传6张，大小不超过2M）"
                    rules={[{ required: true, message: '必须上传图片' }]}
                >
                    <Upload
                        name="files"
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                        fileList={fileList}
                    >
                        {uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item
                    label="选择基本项目"
                    name="item_list_extra"
                    rules={[{ required: true, message: '基本项目' }]}
                >
                    <TreeSelect showSearch virtual={false} treeData={treeData} treeCheckable={true} onChange={handleTreeSelectChange} filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)} />
                </Form.Item>

                {ckSelectedJson.length > 0 && <Form.Item label="项目信息" >
                    <div className="checked-ck-projects">
                        <Row gutter={0} className="title">
                            <Col span="6">项目名称</Col>
                            <Col span="6">标准次数</Col>
                            <Col span="4">删除</Col>
                        </Row>

                        {ckSelectedJson.map((el: any, index: number) => (<Row gutter={0} className="content" key={index}>
                            <Col span="6" style={{ lineHeight: '30px' }}>{el.item_name}</Col>
                            <Col span="6"><InputNumber placeholder="" style={{ width: '90%' }} value={el.standard_times} onChange={(e: any) => { handleProjectChange(e, index, 'standard_times') }} /></Col>
                            <Col span="4"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteTreeOption(el.item_id) }} /></Col>
                        </Row>))}
                    </div>
                </Form.Item>}

                <Form.Item label="参考价格" name="suggest_price" rules={[{ required: true, message: '必须选择参考价格' }]} >
                    <InputNumber style={{ width: 200 }} formatter={limitDecimals} placeholder="请填写参考价格" />
                </Form.Item>

                <Form.Item label="服务详情" name="item_intro_detail" rules={[{ required: true, message: '必须编辑服务详情' }]} >
                    <Button onClick={() => { showEditModal('service') }} icon={<EditOutlined />}>编辑</Button>
                </Form.Item>

                <Form.Item label="温馨提示" name="attention" rules={[{ required: true, message: '必须编辑温馨提示' }]}  >
                    <Button onClick={() => { showEditModal('attention') }} icon={<EditOutlined />}>编辑</Button>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">确定</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        <Modal visible={editorVisible} onCancel={() => { setEditorVisible(false); editor?.txt.html('') }} width="800px" onOk={handleModalOk}>
            <div className="editor" style={{ marginTop: 50 }}></div>
        </Modal>
    </div>
}